import React from "react";
import { Box } from '@mui/joy';
import { Timeline } from 'src/mtska-frontend-app-component';
import { useTranslation } from 'react-i18next';
import PieSet from "./PieSet";
import KPISet from "./KPISet";

const Page = ({ dataProviderName, filters, $key }) => {
    const { t } = useTranslation();

    const showKPI = true;
    const showPIE = true;
    const showTimelineLead = false;


    const getTransposedDate = (months) => {
        const today = new Date();
        today.setMonth(today.getMonth() + months);

        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');

        return `${yyyy}-${mm}-${dd}`;
    }

    const createTimelineBarFilterHandler = (field, addFilter) => (params) => {
        const [monthStr, yearStr] = params.split(' ');
        const month = parseInt(monthStr, 10) - 1;
        const year = parseInt(yearStr, 10);

        const start = new Date(year, month, 1);
        const end = new Date(year, month + 1, 0);

        addFilter(field, params);
    };

    return (
        <Box className="dashboard-page" key={$key}>
            <Box className="dashboard-page-title">
                <h2>{t('Accepted')}</h2>
            </Box>

            {showKPI &&
                <Box className="report-itemgroup">
                    <KPISet dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }

            {showPIE &&
                <Box className="report-itemgroup">
                    <PieSet dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }

            {showTimelineLead &&
                <Box className="dashboard-section-title">
                    <h2>{t('Lead per settimana')}</h2>
                </Box>
            }
            {showTimelineLead &&
                <Box className="report-itemgroup report-itemgroup-timeline" sx={{ marginTop: '10px', marginBottom: '30px' }}>
                    <Box className="report-item">
                        {/* <Timeline
                            title={t("Lead per settimana")}
                            dataProviderName="statisticsviews/leadbyweek/timelined/views_opportunities_lead/registered_at/week"
                            //format="currency"
                            filters={{
                                items: [
                                    ...(settings?.filterModel?.items || []),
                                    {
                                        field: "registered_at",
                                        operator: "between",
                                        value: {
                                            from: getTransposedDate(-12),
                                            to: getTransposedDate(0),
                                        }
                                    }
                                ]
                            }}
                            handleFilterChange={createTimelineBarFilterHandler('registered_at', addFilter)}
                        /> */}
                    </Box>
                </Box>
            }
        </Box>
    )
}

export default Page;